import { createFileRoute } from "@tanstack/react-router";
import { Step4AddTechnician } from "@/features/vendor/onboarding/v1/step-4-add-technician";

export const Route = createFileRoute(
  "/vendors/onboarding/v1/step-4-add-technician",
)({
  component: Step4AddTechnician,
});
